import React, { useEffect } from "react";
import { connect }  from "react-redux";
import { FormattedMessage } from "react-intl";

// @mui/material components
import { Dialog, DialogTitle, DialogContent } from "@mui/material";

// core components
import EditForm from './editForm';

function EditDialog(props) {
    const { sector, closeDialog, isOpen, isSubSector, updated } = props;

    useEffect(() => {
        if (updated) {
            closeDialog();
        }
    }, [updated]);

    return (
        <Dialog
            open={isOpen}
            onClose={closeDialog}
            maxWidth={'sm'}
            scroll={'body'}
        >
            <DialogTitle>
                <FormattedMessage id={isSubSector ? "sector.form.sub.update.title" : "sector.form.update.title"} />
            </DialogTitle>
            <DialogContent>
                <EditForm
                    closeDialog={closeDialog}
                    sector={sector}
                    initialValues={sector}
                />
            </DialogContent>
        </Dialog>
    )
}

const mapStateToProps = state => {
    return {
        updated: state.sector.update.updated,
    }
};

export default connect(
    mapStateToProps,
    null,
)(EditDialog);
